import { render, staticRenderFns } from "./TimelapseSettings.vue?vue&type=template&id=70c10486&"
import script from "./TimelapseSettings.vue?vue&type=script&lang=ts&"
export * from "./TimelapseSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports